import { Link } from 'react-router-dom'

/** Placeholder until we add hardware products/catalog; can later mirror grocery flow */
export function HardwareShopView() {
  return (
    <div className="page page--hardware-shop">
      <header className="hardware-shop-header">
        <Link to="/hardware" className="btn-back" aria-label="Back to hardware store">←</Link>
        <h1 className="page-title">🛒 Hardware Shop</h1>
      </header>
      <div className="empty-state">
        <span className="empty-state-emoji" aria-hidden>🔧</span>
        <h2 className="empty-state-title">Shop coming soon</h2>
        <p className="empty-state-p">
          For now, try <strong>Build</strong> – pick a project and build something step by step!
        </p>
        <Link to="/hardware/build" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>
          Go build
        </Link>
        <Link to="/hardware" className="btn-large btn-secondary" style={{ textDecoration: 'none', marginTop: 12 }}>
          Back to Hardware Store
        </Link>
      </div>
    </div>
  )
}
